<div class="section-header">
  <h2 class="section-title">{{ title }}</h2>
  @if (ctaLabel && ctaRouterLink) {
    <a class="apple-cta apple-cta--blue section-header__btn" [routerLink]="ctaRouterLink">
      <span>{{ ctaLabel }}</span>
      <icon name="navigate_next"></icon>
    </a>
  } @else if (ctaLabel && ctaExternalHref) {
    <a class="apple-cta apple-cta--blue section-header__btn" [href]="ctaExternalHref" rel="noopener">
      <span>{{ ctaLabel }}</span>
      <icon name="navigate_next"></icon>
    </a>
  }
</div>
<div class="jobs-grid">
  @for (job of jobs; track job.id) {
    <div class="job-card" (click)="onJobClick(job)" style="cursor: pointer">
      <h3 class="job-title">{{ job.title }}</h3>
      <div class="job-meta">
        <div class="job-meta-item">
          <icon name="location_on" class="job-icon"></icon>
          <span>{{ jobLocation(job) }}</span>
        </div>
        @if (jobSalary(job)) {
          <div class="job-meta-item">
            <icon name="euro" class="job-icon"></icon>
            <span>{{ jobSalary(job) }}</span>
          </div>
        }
      </div>
      <p class="job-description">{{ job.shortDescription }}</p>
      <button class="job-cta" (click)="onJobClick(job); $event.stopPropagation()">
        <span>Bekijk vacature</span>
      </button>
    </div>
  }
</div>
@if (ctaLabel && ctaRouterLink) {
  <a class="apple-cta apple-cta--blue section-footer__btn" [routerLink]="ctaRouterLink">
    <span>{{ ctaLabel }}</span>
    <icon name="navigate_next"></icon>
  </a>
} @else if (ctaLabel && ctaExternalHref) {
  <a class="apple-cta apple-cta--blue section-footer__btn" [href]="ctaExternalHref" rel="noopener">
    <span>{{ ctaLabel }}</span>
    <icon name="navigate_next"></icon>
  </a>
}
